export enum PerfMeasurerType {
  STATIC,
  DYNAMIC,
}
